/*
 * 4-Б11 «Роли и права» — числа из макета «Доступы, вебхуки, печать - П2»: карточка 700,
 * отступы 10 × 14, чипы ролей с зазором 6, опасные права строками в рамке (радиус 6,
 * высота от 36), разделы в две колонки (зазор 4 × 12), подписи-плашки 9 × 12 радиусом 8.
 */

.screen {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.card {
  display: flex;
  flex-direction: column;
  width: min(700px, 100% - 2 * var(--space-4));
  margin: var(--space-3) var(--space-4);
  overflow: hidden;
  font-size: 12.5px;
  line-height: 1.5;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
}

.head {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  padding: 12px 14px;
  border-bottom: 1px solid var(--border);
}

.headTitle {
  margin: 0;
  font-size: 14px;
  font-weight: var(--font-weight-semibold);
}

.hint {
  font-size: 12px;
  color: var(--text-secondary);
}

.spacer {
  flex: 1;
}

.roles {
  padding: 10px 14px 0;
}

.nameRow {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  padding: 10px 14px 0;
}

.nameField {
  width: 200px;
}

.body {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 14px;
}

.lockedNote {
  padding: 9px 12px;
  margin-bottom: 4px;
  font-size: 12px;
  color: var(--text-brand);
  background: var(--bg-sunken);
  border-radius: 8px;
}

.dangerTitle,
.sectionsTitle {
  margin-top: 4px;
  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.dangerTitle {
  color: var(--danger-hover);
}

.sectionsTitle {
  margin-top: 8px;
  color: var(--text-secondary);
}

.dangerRow {
  min-height: 36px;
  padding: 6px 10px;
  border: 1px solid var(--grid-line-minor);
  border-radius: 6px;
}

.dangerText {
  flex: 1;
}

.dangerText b {
  font-weight: var(--font-weight-semibold);
}

.dangerNote {
  font-size: 11.5px;
  color: var(--text-secondary);
}

.sections {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px 12px;
}

.section {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.sectionRow {
  display: flex;
  gap: 6px;
  align-items: center;
  justify-content: space-between;
  min-height: 32px;
}

.more,
.link {
  padding: 0;
  font: inherit;
  font-size: 11.5px;
  color: var(--text-brand);
  text-decoration: underline;
  cursor: pointer;
  background: none;
  border: 0;
}

.link {
  font-size: inherit;
}

.atoms {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 2px 0 6px 24px;
  font-size: 12px;
}

.notHere {
  padding: 9px 12px;
  margin-top: 8px;
  font-size: 12px;
  color: var(--text-brand);
  background: var(--bg-workspace);
  border-radius: 8px;
}

.notHere b {
  font-weight: var(--font-weight-semibold);
}

.masterNote {
  padding: 9px 12px;
  font-size: 12px;
  /* зелёная плашка макета (#eef0e9 / #647155) — те же пары, что у карантина брони */
  color: var(--hold-quarantine-fg);
  background: var(--hold-quarantine-bg);
  border-radius: 8px;
}

.outcome {
  padding: 9px 12px;
  margin: 0 14px 10px;
  color: var(--text-brand);
  background: var(--bg-sunken);
  border-radius: 8px;
}

.problem {
  padding: 9px 12px;
  margin: 0 14px 10px;
  color: var(--danger);
  border: 1.5px solid var(--danger-hover);
  border-radius: 8px;
}

.foot {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  padding: 10px 14px 14px;
  border-top: 1px solid var(--border);
}

.dialogBody {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  min-width: min(420px, 100%);
}

.dialogButtons {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

@media (max-width: 767px) {
  .card {
    width: auto;
  }

  .sections {
    grid-template-columns: 1fr;
  }

  .nameField {
    width: 100%;
  }
}
